import { render, staticRenderFns } from "./CreateYourOwn.vue?vue&type=template&id=3aad961a&scoped=true"
import script from "./CreateYourOwn.vue?vue&type=script&lang=js"
export * from "./CreateYourOwn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aad961a",
  null
  
)

export default component.exports